import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import Tours from '../components/Tours';
import Gallery from '../components/Gallery';
import Contact from '../components/Contact';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollTo = location.state?.scrollTo;
    if (scrollTo) {
      // Defer to ensure sections are mounted
      setTimeout(() => {
        const element = document.getElementById(scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
        // Clear state so future direct visits don't auto-scroll
        window.history.replaceState({}, document.title);
      }, 100);
    }
  }, [location]);

  return (
    <main>
      <Hero />
      <Tours />
      <Gallery />
      <Contact />
    </main>
  );
};

export default HomePage;
